import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { AccountEntitiy } from 'NewVersion/components/Account/AccountEntity'
import Button from 'NewVersion/components/UI/Buttons/Button'
import { REGISTER_ENTITY_PATH } from 'Routes/Paths'
import { LLOTJA_WORKFLOW_STATE } from 'utils/constants'

function Account({ accreditations, entities, shops, stands, payments, currentEdition }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const hasNoEntities = (entities ?? []).length === 0

  const canOpenAccreditationFlow =
    currentEdition.canCreateEnsProfessionals() ||
    currentEdition.canCreateEnsPremsa() ||
    currentEdition.canCreateEnsServeis()

  const getObjectEnsAndAccreditations = React.useMemo(() => {
    const result = []

    // Filter out non-performing Ens (artist/representant) entities
    const entitiesToShow = entities.filter((e) => {
      // Hide Ens (artist/representant) that are not performing (not published)
      if (e.type_name === 'Ens' && e.review_state !== LLOTJA_WORKFLOW_STATE.published) {
        return false
      }
      return true
    })

    entitiesToShow.forEach((entity) => {
      const accreditationsFilter = accreditations.filter((accreditation) => {
        return accreditation['path'].indexOf(entity['@name']) !== -1
      })
      const shopsFilter = shops.filter((shop) => {
        return shop['path'].indexOf(entity['@name']) !== -1
      })
      const standsFilter = stands.filter((stand) => {
        return stand['path'].indexOf(entity['@name']) !== -1
      })
      const paymentFilter = payments.filter((payment) => {
        return payment['path'].indexOf(entity['@name']) !== -1
      })
      result.push({
        entity,
        accreditations: accreditationsFilter,
        shops: shopsFilter,
        stands: standsFilter,
        payments: paymentFilter,
      })
    })

    return result
  }, [accreditations, entities, shops, stands, payments])

  return (
    <section className="account page-wrapper">
      <h1>{t('El meu perfil')}</h1>
      {hasNoEntities && (
        <div className="wrapper-empty-info account-no-pro-press-service">
          <b>{t('account_no_professional_press_service_entity')}</b>
          <div className="account-no-pro-press-service__cta">
            <Button
              type="button"
              color="primary"
              dataTest="accountAccreditAsProfessionalCta"
              onClick={() => navigate(REGISTER_ENTITY_PATH)}
              disabled={!canOpenAccreditationFlow}
            >
              {t('si_vols_acreditacio_professional')}
            </Button>
          </div>
        </div>
      )}
      {entities.length > 0 ? (
        <div className="account-class">
          {getObjectEnsAndAccreditations.map((objEnsAndAccreditations, index) => {
            const pastTypeName = getObjectEnsAndAccreditations[index - 1]?.entity.tipus || ''
            const presentTypeName = objEnsAndAccreditations.entity.tipus
            return (
              <>
                {pastTypeName !== presentTypeName && presentTypeName === 'artista' && (
                  <>
                    <div className="separator-entity" />
                    <h2>{t('Artista')}</h2>
                  </>
                )}
                <AccountEntitiy
                  entityInfo={objEnsAndAccreditations}
                  key={objEnsAndAccreditations.entity['@id']}
                  currentEdition={currentEdition}
                />
              </>
            )
          })}
        </div>
      ) : null}
    </section>
  )
}

export default memo(Account)
